import { untag } from '@suntex.core/types';
import {
  $KnowAndShowCategory,
  $KnowAndShowLevel,
  $ModuleArea,
  KnowAndShowLevel,
  ModuleArea,
} from '@suntex.fim/enums';

import { ModuleSlug, NodeModel } from '../../types';

const K2_DATA_TARGET = 12;
const K3_TO_K5_DATA_TARGET = 24;

export function buildKSLevelNode({
  level,
  duplicate,
}: {
  level: KnowAndShowLevel;
  duplicate?: boolean;
}): NodeModel {
  const levelDesc = $KnowAndShowLevel.describe(level);
  const levelValueKey = `${untag(levelDesc.value)}` as const;
  const children = [] as NodeModel[];

  for (const categoryDesc of $KnowAndShowCategory.describeAll()) {
    if (categoryDesc.value > levelDesc.categoryCount) continue;
    const slug = `ks-${level}-${categoryDesc.value}` as ModuleSlug;
    const categoryValueKey = `${untag(categoryDesc.value)}` as const;

    children.push({
      moduleSlug: slug,
      href: '/modules/word-problems/' + level + '/' + categoryDesc.value,
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      dataPath: ['ks', levelValueKey, categoryValueKey as string],
      dataTarget: levelDesc.isK2 ? K2_DATA_TARGET : K3_TO_K5_DATA_TARGET,
      icon: `ks-categories/${categoryValueKey}`,
      label: categoryDesc.label,
      info: {
        title: categoryDesc.label,
        summary: categoryDesc.skills,
      },
      duplicate,
      color: levelDesc.color,
    });
  }

  return {
    tag: levelDesc.slug,
    alias: [levelValueKey],
    icon: `modules/ks/${levelDesc.slug}`,
    label: {
      aria: levelDesc.label,
    },
    filtered: {
      label: levelDesc.label,
      color: $ModuleArea.describe(ModuleArea.KnowAndShow).color,
    },
    duplicate,
    color: levelDesc.color,
    layout: 'clock',
    children,
  };
}
